/* global process */
import '@hotwired/turbo-rails';
import '../controllers';
import '../modules/jquery';
import 'jquery-mask-plugin';

import * as Sentry from '@sentry/browser';

Sentry.init({
  dsn: 'https://7586bc971f6f12ca0f0bc72be723bef2@o4508813594263552.ingest.us.sentry.io/4508813708754944',
  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/configuration/options/#sendDefaultPii
  sendDefaultPii: true,

  enabled: process.env.NODE_ENV === 'production',

  // Desabilita SessionReplay completamente
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,

  ignoreErrors: [
    // Erros de navegador/extensões
    'ResizeObserver loop limit exceeded',
    'ResizeObserver loop completed with undelivered notifications',
    'Non-Error promise rejection captured',
    // Erros de conexão
    'NetworkError',
    'Failed to fetch',
    'Load failed',
    'AbortError',
    /AbortError: The user aborted a request/,
    // Erros do Chrome
    'Extension context invalidated',
    'The operation is insecure',
    // Erros de terceiros
    /^chrome-extension:/,
    /^moz-extension:/,
  ],

  // eslint-disable-next-line no-unused-vars
  beforeSend(event, _) {
    // Filtra erros de desenvolvimento
    if (window.location.hostname === 'localhost') {
      return null;
    }

    return event;
  },

  // Alternatively, use `process.env.npm_package_version` for a dynamic release version
  // if your build tool supports it.
  integrations: [Sentry.browserTracingIntegration()],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for tracing.
  // We recommend adjusting this value in production
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
  tracesSampleRate: 0.5,
});

// TODO: Improves bundle SW-4685
import '../modules/moment'; // Only used for tempusdominus-bootstrap-4
import 'tempusdominus-bootstrap-4';

import Rails from '@rails/ujs';

Rails.start();

// Loads Boostrap
import * as bootstrap from 'bootstrap';

let popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
popoverTriggerList.map(function (popoverTriggerEl) {
  return new bootstrap.Popover(popoverTriggerEl);
});

// Bootstrap Table
import 'bootstrap-table/src/bootstrap-table';
import 'bootstrap-table/src/extensions/fixed-columns/bootstrap-table-fixed-columns';
import 'bootstrap-table/src/extensions/sticky-header/bootstrap-table-sticky-header';

// Loads Selects
import select2 from 'select2';
import 'bootstrap-select';
import localizePTBR from '../select2/pt-BR';

select2($);
$.fn.select2.defaults.set('theme', 'bootstrap');
$.fn.select2.defaults.set('language', localizePTBR);

// TODO: Adds Pagy js
// import Pagy from "pagy-module";

// window.addEventListener("turbo:load", Pagy.init);

// Summernote
import 'summernote/dist/summernote-bs4';
import 'summernote/dist/lang/summernote-pt-BR';
import '../summernote/plugins/summernote-math';
import '../modules/summernote';

// Katex
import katex from 'katex';

window.katex = katex;

// Chart JS
import Chart from 'chart.js/auto';

window.Chart = Chart;

// Disable datalabels plugin globally by default
Chart.defaults.plugins.datalabels = {
  display: false,
};

// Custom globals files
import '../modules/global';
import '../modules/utils';
import '../modules/grades';

// Show progress bar again [https://github.com/hotwired/turbo/issues/540]
const adapter = Turbo.navigator.delegate.adapter;
const progressBar = adapter.progressBar;
const session = Turbo.session;

let progressBarTimeout = null;

Turbo.config.drive.progressBarDelay = 400;
document.addEventListener('turbo:before-fetch-request', (event) => {
  const target = event.target;
  if (!(target instanceof HTMLElement)) {
    return;
  }

  if (target.getAttribute('data-turbo-progress-bar') === 'false') {
    return;
  }

  if (!progressBarTimeout) {
    progressBar.setValue(0);
  }

  progressBarTimeout = window.setTimeout(() => progressBar.show(), session.progressBarDelay);
});

document.addEventListener('turbo:before-fetch-response', () => {
  if (progressBarTimeout) {
    window.clearTimeout(progressBarTimeout);
    progressBar.hide();
    progressBarTimeout = null;
  }
});
